import { Tooltip } from '@blueprintjs/core';
import { PopoverPosition } from '@blueprintjs/core';
import { faCopy } from '@fortawesome/free-regular-svg-icons/faCopy';
import { IconButton } from 'es/app/components/buttons/IconButton';
import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import { ButtonHTMLAttributes, useState } from 'react';
import { useDebounce } from 'react-use';

interface IProps {
    text: string;
    tooltipPosition?: PopoverPosition;
}

const CopyToClipboard = withSuspense(
    ({ text, tooltipPosition = PopoverPosition.LEFT, ...rest }: IProps & ButtonHTMLAttributes<HTMLButtonElement>) => {
        const { l10n } = useI18n('app/components');

        const [showCopiedTooltip, setShowCopiedTooltip] = useState<boolean>(false);
        const [hideCopiedTokenMessageAfterDelay] = useDebounce(() => setShowCopiedTooltip(false), 3000, [
            showCopiedTooltip,
        ]);

        return (
            <>
                <Tooltip
                    content={l10n('buttons.copiedToClipboard')}
                    isOpen={showCopiedTooltip}
                    position={tooltipPosition}
                >
                    <IconButton {...rest} icon={faCopy} type="button" onClick={handleCopyTokenClick} />
                </Tooltip>
            </>
        );

        async function handleCopyTokenClick() {
            await navigator.clipboard.writeText(text);

            const showCopiedTokenMessage = () => {
                setShowCopiedTooltip(true);
                hideCopiedTokenMessageAfterDelay();
            };

            if (showCopiedTooltip) {
                setShowCopiedTooltip(false);
                setTimeout(showCopiedTokenMessage, 100);
            } else {
                showCopiedTokenMessage();
            }
        }
    }
);

export default CopyToClipboard;
